// extracted by mini-css-extract-plugin
export default {"noMessages":"QueueStatus-noMessages-a1G0a"};